module.exports = __webpack_public_path__ + "media/images/pic/saska/speaking-64ad1161e36283b97ed4707517b1544f.png";